$(document).ready(function () {

	$('.accordion').each(function () {
		var $accordeon = $(this);
		if ($accordeon.hasClass("firstopened")) {
			$accordeon.find('> .item').eq(0).addClass("open");
		}
	});
	
	$('.btnAccordion').each(function () {
		var $button = $(this);
		var $item = $(this).parent('.item');
		var $carousel = $item.find('.carousel');
		$button.on('click', function () {
			$item.toggleClass('open');
			if ($carousel.length > 0) {
				setTimeout(function () {
					$carousel.slick('setPosition');
				}, 1);
			}
		});
	});

	/*
	$(".accordion").each(function(){
		
		//
		//var accLayoutType = 'fitRows';
		var accContainer = this;
		var accStayOpened = true;
		if ( $(this).hasClass("firstopened") ) var accFirstOpened = true;
		
		
		//
		$('.btnAccordion',accContainer).click(function() {
			
			if ( $(accContainer).hasClass("stayopened") ) {
				accStayOpened = true;
			}
			if ( $(this).parent().hasClass('open') ) {
				$(this).parent().removeClass('open');
				
			} else {
				if ( accStayOpened == false ) {
					$('.btnAccordion',accContainer).parent().removeClass('open');
				}
				$(this).parent().addClass('open');
			}
			
		});
		
		
		//
		if ( accFirstOpened === true ) {
			
			$(".item",accContainer).eq(0).addClass("open");
		
		}
		
		
	});
	*/


});